import React, { ChangeEvent, useCallback, useState } from 'react';
import SearchContacts from './SearchContacts';
import { ChatStateEnum, ChatTypeEnum } from '../../../../enums/chat-enum';
import { useGetFriendsByUserIdQuery } from '../../../../store/apiSlice/friendApi';
import {
  useCreateChatMutation,
  useGetAllMyChatsQuery,
} from '../../../../store/apiSlice/chat/chatApi';
import { useDispatch } from 'react-redux';
import {
  setChatsLoaded,
  setChatState,
  setChatType,
  setSelectedChat,
} from '../../../../store/apiSlice/chat/chatSlice';
import ChatSuggestionsList from '../ChatSuggestionsList/ChatSuggestionsList';
import { IFriend } from '../../../../interfaces/friend.interface';
import useDebounce from '../../../../hooks/useDebounce';

const NewPersonalChat = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const { data: myChats } = useGetAllMyChatsQuery();
  const [createChat] = useCreateChatMutation();
  const dispatch = useDispatch();

  const debouncedSearch = useDebounce(searchValue, 500);
  const { data } = useGetFriendsByUserIdQuery({
    page: 1,
    limit: 10,
    search: debouncedSearch,
    sort: 'desc',
  });

  const handleCreateChat = useCallback(
    async (friend: IFriend) => {
      const withUserId = friend.userId;
      try {
        const existingChat = myChats?.find(
          (chat) => chat.withUserId === withUserId
        );
        if (existingChat) {
          dispatch(setSelectedChat(existingChat));
        } else {
          const chat = await createChat(withUserId).unwrap();
          dispatch(setSelectedChat(chat));
        }
        setSearchValue('');
        dispatch(setChatType(ChatTypeEnum.PERSONAL));
        dispatch(setChatState(ChatStateEnum.CHAT));
        dispatch(setChatsLoaded());
        //eslint-disable-next-line
      } catch (error) {
        // Silently fail - error handled by parent component
      }
    },
    [myChats, dispatch, createChat]
  );

  return (
    <>
      <SearchContacts
        onSearch={(e: ChangeEvent<HTMLInputElement>) =>
          setSearchValue(e.target.value)
        }
      />

      <ChatSuggestionsList
        friends={data?.friends ?? []}
        onClick={handleCreateChat}
      />
    </>
  );
};

export default NewPersonalChat;
